/**
 * VoiceClient — provider-agnostic abstract client for Voice AURI.
 *
 * Concrete implementations (OpenAIRealtimeClient today, ElevenLabsClient
 * tomorrow) extend this and emit the same event API so the React UI never
 * needs to know which provider is active.
 *
 * Event contract (subclasses MUST emit these):
 *   connecting | connected | listening | thinking | speaking |
 *   transcript ({role,text,final})   → live user or assistant transcript
 *   toolcall  ({name,args,result})   → toolcalls resolved by backend
 *   state     ({state})              → convenience for orb rendering
 *   interruption ()
 *   error     ({message,recoverable})
 *   ended     ({reason,usage})
 */
export class VoiceClient {
  constructor() {
    this._listeners = {};
  }
  on(event, cb) {
    (this._listeners[event] ||= new Set()).add(cb);
    return () => this._listeners[event]?.delete(cb);
  }
  emit(event, payload) {
    this._listeners[event]?.forEach((cb) => {
      try { cb(payload); } catch (e) { console.warn("VoiceClient listener error", e); }
    });
  }

  async connect(_opts) { throw new Error("abstract"); }
  async mute() { throw new Error("abstract"); }
  async unmute() { throw new Error("abstract"); }
  async sendText(_text) { throw new Error("abstract"); }
  async end() { throw new Error("abstract"); }
  getUsage() { return { audioInputSeconds: 0, audioOutputSeconds: 0, inputTokens: 0, outputTokens: 0, interruptions: 0, userTurns: 0, languageDetected: null }; }
}
